import styled from 'styled-components'

export const HeaderDiv = styled.div`
    width: 100%;
    background-color: #82AA37;
    border: 3px solid #3F5C09;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    border-top: none;
    height: 50px;
    font-size: 20px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;
    text-decoration: none;
    margin-bottom: 30px;
`;

